import http from '@/utils/request'

 export default {
  monitorList: {
    url: 'patent/patentInfo/list',
    name: '监控列表',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  monitorAdd: {
    url: 'patent/patentInfo/add',
    name: '新建年费监控',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  setMonitor: { // 监控列表/未监控列表
    url: 'patent/patentInfo/updateMonitorTypeByIds',
    name: '设为监控',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  namedAccount: { // 监控列表--指定客户
    url: 'patent/patentInfo/updateCustomerIdByIds',
    name: '指定客户',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  changeMonitorUser: { // 监控列表--变更监控负责人
    url: 'patent/patentInfo/updateMonitorUserIdByIds',
    name: '变更监控负责人',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  changePayPattern: { // 监控列表--变更缴费方式
    url: 'patent/patentInfo/updatePayTypeByIds',
    name: '变更缴费方式',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  editRemark: { // 监控列表--变更备注
    url: 'patent/patentInfo/updateRemarkByIds',
    name: '编辑备注',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  changePayStatus: { // 监控列表--变更缴费状态
    url: 'patent/patentInfo/updateUnPayStatusByIds',
    name: '变更缴费状态',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  handleSync: { // 监控列表--同步
    url: 'patent/patentInfo/updatePatentData',
    name: '同步',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  handleDownload: { // 监控列表--下载
    url: 'patent/applicant/downloadZip',
    name: '下载多个专利信息表格',
    get: async function(data, config={responseType: 'blob'}) {
      return await http.get(this.url, data, config)
    }
  },
  handleMonitor: { // 监控列表--监控
    url: 'patent/applicant/getApplyNo',
    name: '同步',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  createOfficialCustomerList: { // 监控列表--创建官方账单/创建客户确认单
    url: 'patent/patentInfo/addOfficialBill',
    name: '创建官方账单/创建客户确认单',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  templateExport: { // 监控列表--通过模板导入
    url: 'patent/patentInfo/importByExcel',
    name: '通过模板导入',
    post: async function(data, config={headers:{'Content-Type': 'multipart/form-data;charset=UTF-8'}}) {
      return await http.post(this.url, data, config)
    }
  },
  getAnnualFeeDetail: { // 监控列表--监控编号详情
    url: 'patent/patentInfo/getInfo',
    name: '专利年费信息',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  monitorInfoEdit: { // 监控详情--专利信息-监控信息保存
    url: 'patent/patentInfo/edit',
    name: '监控信息保存',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  patentFileUpload: { // 监控详情--专利附件上传
    url: 'patent/patentInfo/upload/patentFile',
    name: '专利附件上传',
    post: async function(data, config={headers:{'Content-Type': 'multipart/form-data;charset=UTF-8'}}) {
      return await http.post(this.url, data, config)
    }
  },
  messageFileUpload: { // 往来文件上传
    url: 'patent/fileInfo/upload',
    name: '专利附件上传',
    post: async function(data, config={headers:{'Content-Type': 'multipart/form-data;charset=UTF-8'}}) {
      return await http.post(this.url, data, config)
    }
  },
  getPatentFile: { // 监控详情--专利附件列表
    url: 'patent/patentInfo/file/info',
    name: '专利附件列表',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  delPatentFile: { // 监控详情--专利附件列表-删除
    url: 'patent/patentInfo/file',
    name: '删除',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  getStatisticPatentCount: { // 监控列表--监控数量
    url: 'patent/patentInfo/getStatisticPatentCount',
    name: '监控数量',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  getStatisticAuthorizePatent: { // 仪表盘--授权专利统计
    url: 'patent/patentInfo/getStatisticAuthorizePatent',
    name: '授权专利统计',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  getStatisticAgency: { // 仪表盘--代理机构
    url: 'patent/patentInfo/getStatisticAgency',
    name: '代理机构',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  getStatisticInventorRanking: { // 仪表盘--发明人
    url: 'patent/patentInfo/getStatisticInventorRanking',
    name: '发明人',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  getStatisticPatentApplyCount: { // 仪表盘--申请量
    url: 'patent/patentInfo/getStatisticPatentApplyCount',
    name: '申请量',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  getStatisticPatentProgress: { // 仪表盘--案件进度
    url: 'patent/patentInfo/getStatisticPatentProgress',
    name: '案件进度',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  getStatisticPatentReview: { // 仪表盘--案件审查
    url: 'patent/patentInfo/getStatisticPatentReview',
    name: '案件审查',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  applicantAdd: {
    url: 'patent/applicant/add',
    name: '申请人新增',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  applicantList: { // 申请人列表
    url: 'patent/applicant/list',
    name: '申请人列表',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  applicantDel: {
    url: 'patent/applicant/delete',
    name: '申请人删除',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  applicantSync: {
    url: 'patent/applicant/updatePatentData',
    name: '申请人同步',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  getApplicantDetail: {
    url: 'patent/applicant/getInfo',
    name: '申请人详情',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  billList: {
    url: 'patent/patentOfficialBill/list',
    name: '官方账单列表',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  billChangeStatus: {
    url: 'patent/patentOfficialBill/updateOfficialBillStatusByIds',
    name: '变更账单状态',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  billChangeRemark: {
    url: 'patent/patentOfficialBill/updateRemarkByIds',
    name: '备注',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  monitorChartStatis: { // 年费监控/案件状态/期限管控
    url: 'patent/patentInfo/getStatisticPatentFeeMonitor',
    name: '仪表盘数字统计',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  getContactList: {
    url: '/patent/contact/list',
    name: '联系人列表',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  contactAdd: {
    url: 'patent/contact/add',
    name: '联系人新增',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  contactEdit: {
    url: 'patent/contact/edit',
    name: '联系人修改',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  pullDownPatentCustomer: {
    url: 'patent/customer/pullDownPatentCustomer',
    name: '客户下拉列表不分页',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  contactDelete:{
    url: 'patent/contact/delete',
    name: '联系人删除',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  updateContactStatusByIds:{
    url: 'patent/contact/updateContactStatusByIds',
    name: '联系人禁用启用',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  getCustomerList: {
    url: 'patent/customer/list',
    name: '监控客户列表',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  customerAdd: {
    url: 'patent/customer/add',
    name: '监控客户新增',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  customerEdit: {
    url: 'patent/customer/edit',
    name: '监控客户修改',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  customerDelete: {
    url: 'patent/customer/delete',
    name: '监控客户删除',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  turnDirector: { // 监控客户--指派监控负责人
    url: 'patent/customer/updateMonitorChargePersonByIds',
    name: '指派监控负责人',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  turnDirectorPeopleList: {
    url: 'system/user/getDeptUserList',
    name: '指派监控负责人下拉数据',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  changeBillStatus: {// 官方账单
    url: 'patent/patentOfficialBill/updateOfficialBillStatusByIds',
    name: '变更账单状态',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  billEditRemark: {// 官方账单
    url: 'patent/patentOfficialBill/updateRemarkByIds',
    name: '备注',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  exportOfficialBill: {// 官方账单
    url: 'patent/patentOfficialBill/officialBill/export',
    name: '导出官方账单',
    post: async function(data, config={responseType: 'blob'}) {
      return await http.post(this.url, data, config)
    }
  },
  patentConfirmBillExport: {// 下载客户确认单
    url: 'system/patentConfirmBill/export',
    name: '下载客户确认单',
    post: async function(data, config={responseType: 'blob'}) {
      return await http.post(this.url, data, config)
    }
  },
  getInfoBill: { // 官方账单
    url: 'patent/patentOfficialBill/getInfo',
    name: '详情',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  handleLogList: { // 官方账单-详情
    url: 'patent/handleLog/list',
    name: '操作记录',
    post: async function(params) {
      return await http.post(this.url, params)
    }
  },
  officialFeeList: { // 官方账单-详情
    url: 'patent/patentInfoBill/list',
    name: '官方费用清单列表',
    post: async function(params) {
      return await http.post(this.url, params)
    }
  },
  officialFeeListDelete: { // 官方账单-详情-官方费用清单列表
    url: 'patent/patentInfoBill/delete',
    name: '删除',
    post: async function(params) {
      return await http.post(this.url, params)
    }
  },
  officialFeeListEdit: { // 官方账单-详情-官方费用清单列表
    url: 'patent/patentInfoBill/edit',
    name: '编辑',
    post: async function(params) {
      return await http.post(this.url, params)
    }
  },
  confirmationListBill: { // 官方账单-详情-客户确认单
    url: 'system/patentConfirmBill/listPatentConfirmBill',
    name: '客户确认单',
    post: async function(params) {
      return await http.post(this.url, params)
    }
  },
  confirmationList: { // 客户确认单
    url: 'system/patentConfirmBill/list',
    name: '客户确认单列表',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  getInfoConfirmation: { // 客户确认单
    url: 'system/patentConfirmBill/getInfo',
    name: '详情',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  changeStatus: { // 客户确认单
    url: 'system/patentConfirmBill/updateBillStatusByIds',
    name: '变更状态',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  confirmationEditRemark: { // 客户确认单
    url: 'system/patentConfirmBill/updateRemarkByIds',
    name: '备注',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  downloadZip: { // 客户确认单
    url: 'system/patentConfirmBill/exportTemplateZip',
    name: '下载zip包',
    post: async function(data, config={responseType: 'blob'}) {
      return await http.post(this.url, data, config)
    }
  },
  agencyPage: {
    url: 'patent/patentInfo/agency/page',
    name: '代理机构',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  }
 }